/* eslint-disable no-dupe-keys */
import { getRequiredFields } from 'utils/form'
import constants from 'constants'

const fields = [
  {
    label: '',
    name: 'beneficiaryId',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },
  {
    label: 'Type *',
    name: 'type',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please select a type',
  },
  {
    label: 'Choose from prior beneficiary data',
    name: 'historicalData',
    type: 'select',
    layout: 'fullWidth',
    requestOptions: true,
    options: [],
    searchable: true,
  },
  {
    label: '',
    name: 'amountMax',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },
  {
    label: 'First name *',
    name: 'firstName',
    layout: 'fullWidth',
    maxLength: 100,
    validators: [
      {
        check: 'requiredIf',
        fields: 'firstName|type',
        error: 'Please enter first name',
        conditions: constants.BENEFICIARY.TYPE.INDIVIDUAL,
      },
    ],
  },
  {
    label: 'Date of birth *',
    name: 'dob',
    layout: 'fullWidth',
    validators: [
      {
        check: 'requiredIf',
        fields: 'dob|type',
        error: 'Please enter date of birth',
        conditions: constants.BENEFICIARY.TYPE.INDIVIDUAL,
      },
    ],
  },
  {
    label: 'Last name *',
    name: 'lastName',
    layout: 'fullWidth',
    maxLength: 255,
    validators: [
      {
        check: 'requiredIf',
        fields: 'lastName|type',
        error: 'Please enter last name',
        conditions: constants.BENEFICIARY.TYPE.INDIVIDUAL,
      },
    ],
  },
  {
    label: 'Company name *',
    name: 'companyName',
    layout: 'fullWidth',
    maxLength: 255,
    validators: [
      {
        check: 'requiredIf',
        fields: 'companyName|type',
        error: 'Please enter company name',
        conditions: constants.BENEFICIARY.TYPE.COMPANY,
      },
    ],
  },
  {
    label: 'Trust name *',
    name: 'trustName',
    layout: 'fullWidth',
    maxLength: 255,
    validators: [
      {
        check: 'requiredIf',
        fields: 'trustName|type',
        error: 'Please enter trust name',
        conditions: constants.BENEFICIARY.TYPE.TRUST,
      },
    ],
  },
  {
    label: 'Trustee name',
    name: 'trusteeName',
    layout: 'fullWidth',
    maxLength: 255,
  },
  {
    label: 'TFN *',
    name: 'tfn',
    layout: 'fullWidth',
    maxLength: 9,
    validators: [
      {
        check: 'requiredTFN',
      },
    ],
    error: 'Invalid TFN, only numbers are allowed and must be 8 or 9 digits long',
  },
  {
    label: '',
    name: 'amountType',
    type: 'radioGroup',
    layout: 'fullWidth',
    // requestOptions: false,
    radios: [{ value: 'fixed', label: 'Fixed' }, { value: 'max', label: 'Max' }],
    searchable: false,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please select an amount type',
  },
  {
    label: 'Amount *',
    name: 'amount',
    layout: 'fullWidth',
    maxLength: 15,
    validators: [
      {
        check: 'requiredNumberIf',
        fields: 'amount|amountType',
        error: 'Please enter a valid amount',
        conditions: 'fixed',
      },
      {
        check: 'isDistributionAmountValid',
        fields: 'amount|amountMax',
        error: 'Please enter a different amount. The amount you have entered exceeds the maximum amount allowed under the Policy. If you have any questions please reach out to your National Partner Services Tax Compliance Manager.',
      },
    ],
    error: 'Please enter amount',
  },
  {
    label: 'Effective date',
    name: 'effectiveDate',
    layout: 'fullWidth',
    maxLength: 40,
  },
  {
    label: 'Address line 1 *',
    name: 'address1',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please enter a address',
  },
  {
    label: 'Address line 2',
    name: 'address2',
    layout: 'fullWidth',
    maxLength: 50,
    // validators: [],
    error: '',
  },
  {
    label: 'Suburb',
    name: 'suburb',
    layout: 'fullWidth',
    maxLength: 50,
    validators: [
      {
        priority: 1,
        check: 'either',
        fields: 'suburb|city',
        error: 'Please enter either a suburb or city',
      },
    ],
  },
  {
    label: 'City',
    name: 'city',
    layout: 'fullWidth',
    maxLength: 20,
    validators: [
      {
        priority: 2,
        check: 'either',
        fields: 'suburb|city',
        error: 'Please enter a suburb or city',
      },
    ],
  },
   {
    label: 'State',
    name: 'state',
    layout: 'fullWidth',
    maxLength: 20,
    error: '',
  },
  {
    label: 'Postcode *',
    name: 'postcode',
    layout: 'fullWidth',
    maxLength: 5,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please enter a postcode',
  },
  {
    label: 'Country',
    name: 'country',
    layout: 'fullWidth',
    maxLength: 20,
    // validators: [],
    error: '',
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/BeneficiaryForm.js